<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Bill Of Process Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-sequence" label-cols-lg="12" label="Sequence" label-for="input-sequence" size="sm" :model.sync="model.sequence" :isRequired="true" :state="validateState('sequence')" :errorMessage="getErrorMessage(errorMessage.sequence, 'sequence')"  />
				<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Machine" id="input-" size="sm" :model.sync="model.machineId"   :selected="model.machine != null ? model.machine.code : ''" @input="getMachines" />
				<app-input-combobox-autocomplete :options="subprocesss" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Sub Process" id="input-" size="sm" :model.sync="model.subProcessId"   :selected="model.subProcess != null ? model.subProcess.code : ''" @input="getSubprocesss" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-label id="fieldset-dies-or-jig-number" type="generatednumber" label-cols-lg="12" label="Dies / Jig" label-for="input-dies-or-jig-number" size="sm" :model.sync="model.diesOrJigNumber" />
				<app-label id="fieldset-sub-process-number" type="generatednumber" label-cols-lg="12" label="Sub Process Number" label-for="input-sub-process-number" size="sm" :model.sync="model.subProcessNumber" />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import BillOfProcessDetail from '@/models/BillOfProcess/BillOfProcessDetail';
import BillOfProcessDetailFilter from '@/filters/BillOfProcess/BillOfProcessDetailFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import Subprocess from '@/models/Subprocess/Subprocess';
import SubprocessFilter from '@/filters/Subprocess/SubprocessFilter';
import AppLabel from '@/components/AppLabel';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppLabel,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			sequence: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				sequence: { required : "Sequence is Required."},
			},
			machines : [],
			subprocesss : [],
			isBusy: false,
		}
	},
	methods : {
		getBillOfProcessDetail : async function(id) {
			this.isBusy = true;
			BillOfProcessDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
			})
			.catch(error => {});
		},
		getSubprocesss : async function(input) {
			let filter = new SubprocessFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Subprocess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subprocesss = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getMachines();
		//this.getSubprocesss();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getBillOfProcessDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getMachines();
				this.getSubprocesss();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getBillOfProcessDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
